import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import { Input, Select, Spin } from "antd";
import AudioPlayer from "../audioPlayer";
import { DateRange } from "react-date-range";
import { format, sub } from "date-fns";
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { ColumnsType, FilterDropdownProps } from "antd/es/table/interface";

type Permission = { id: number; name: string };
type Admin = {
    student_id: number;
    SCS_Number: string;
    name: string;
    no_of_calls: number;
    category_name: string;
    subcategory_name: string;
    agent_name: string;
    is_last_year_paid: string;
    trainer_name: string;
};

type Category = {
    category_id: number;
    category_name: string;
};

type SubCategory = {
    subcategory_id: number;
    subcategory_name: string;
};

type Agent = {
    id: number;
    username: string;
};

type Priority = {
    priority_id: number;
    priority_name: string;
};

type Class = {
    class_name_id: number;
    name: string;
    label: string;
}


const WizklubTrainerStudents = () => {
    const routes = all_routes;
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const paramId = searchParams.get("id");

    if (paramId !== null && !isNaN(Number(paramId))) {
        localStorage.setItem("id", paramId);
    }

    const id = Number(localStorage.getItem("id"));

    const s1 = Number(searchParams.get("s1"));
    const data = exam;
    const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${month}-${day}-${year}`;
    const defaultValue = dayjs(formattedDate);
    const jwtToken = Cookies.get("authToken");
    const { userPermissions, webApi } = useUserPermissions();
    const [isLoading, setIsLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [admin, setAdmin] = useState<Admin[]>([]);
    const [from, setFrom] = useState();
    const [to, setTo] = useState<number>();
    const [totalCount, setTotalCount] = useState();
    const [toastMessage, setToastMessage] = useState("");
    const [showSuccessToast, setShowSuccessToast] = useState(false);
     const [currentPage, setCurrentPage] = useState(() => {
    const savedPage = localStorage.getItem("wizklubTrainerStudentsCurrentPage");
    return savedPage ? JSON.parse(savedPage) : 1;
  });
  useEffect(() => {
    localStorage.setItem("wizklubTrainerStudentsCurrentPage", JSON.stringify(currentPage));
  }, [currentPage]);
    const [pageSize, setPageSize] = useState<number>(10);
    const [searchText, setSearchText] = useState<string>("");
    const [playingAudio, setPlayingAudio] = useState<string | null>(null);
    const audioRefs = useRef<{ [key: string]: HTMLAudioElement | null }>({});
    const [showCalendar1, setShowCalendar1] = useState(false);
    const [categories, setCategories] = useState<Category[]>([]);
    const [subCategories, setSubCategories] = useState<SubCategory[]>([]);
    const [priorities, setPriorities] = useState<Priority[]>([]);
    const [classes, setClasses] = useState<Class[]>([]);
    const [selectedClass, setSelectedClass] = useState<number>(0);
    const [selectedCategory, setSelectedCategory] = useState<number>(0);
    const [selectedSubCategory, setSelectedSubCategory] = useState<number>(0);
    const [selectedAgent, setSelectedAgent] = useState<number>(0);
    const [selectedTrainer, setSelectedTrainer] = useState<number>(0);
    const [selectedPriority, setSelectedPriority] = useState<number>(0);
    const [nameSearch, setNameSearch] = useState("");
    const [scsNumberSearch, setScsNumberSearch] = useState("");
    const handleClearCategory = () => setSelectedCategory(0);
    const handleClearSubCategory = () => setSelectedSubCategory(0);
    const handleClearAgent = () => setSelectedAgent(0);
    const handleClearTrainer = () => setSelectedTrainer(0);
    const handleClearPriority = () => setSelectedPriority(0);
    const handleClearClass = () => setSelectedClass(0);
    const [agentsDropdown, setAgentsDropdown] = useState<Agent[]>([]);
    const [trainerDropdown, setTrainerDropdown] = useState<Agent[]>([]);
    const [selectedIsLastYearPaid, setSelectedIsLastYearPaid] = useState("");

    const handleClearIsLastYearPaid = () => {
        setSelectedIsLastYearPaid("");
    };
    // const [startDate, setStartDate] = useState<string | null>(null);
    // const [endDate, setEndDate] = useState<string | null>(null);

    //   const [dateRange, setDateRange] = useState([
    //     {
    //       startDate: initialStartDate
    //         ? new Date(initialStartDate)
    //         : new Date(new Date().setHours(0, 0, 0, 0)),
    //       endDate: initialEndDate
    //         ? new Date(initialEndDate)
    //         : new Date(new Date().setHours(0, 0, 0, 0)),
    //       key: "selection",
    //     },
    //   ]);

    //   const startDate = format(dateRange[0].startDate, "yyyy-MM-dd");
    //   const endDate = format(dateRange[0].endDate, "yyyy-MM-dd");

    const handlePlayPause = (id: string) => {
        const currentAudio = audioRefs.current[id];

        if (currentAudio) {
            if (playingAudio === id) {
                currentAudio.pause();
                setPlayingAudio(null);
            } else {
                if (playingAudio !== null) {
                    const previousAudio = audioRefs.current[playingAudio];
                    if (previousAudio) {
                        previousAudio.pause();
                    }
                }
                currentAudio
                    .play()
                    .then(() => setPlayingAudio(id))
                    .catch((error) => {
                        console.error("Error playing audio:", error);
                        setPlayingAudio(null);
                    });
            }
        }
    };

    //   const handleFetchData = () => {
    //     if (startDate && endDate) {
    //       fetchData(id, currentPage, pageSize, searchText, startDate, endDate); // Call fetchData with date range
    //       // Hide the date range picker after selecting dates
    //       setShowCalendar1(false);
    //     }
    //   };

    const checkPermission = (action: any, subject: any) => {
        return userPermissions.some(
            (ability) => ability.action === action && ability.subject === subject
        );
    };

    useEffect(() => {
        if (!checkPermission("can_view_wizklub_trainer_student", "wizklubticket")) {
            navigate(routes.crmLandingPage);
        } else {
            fetchData(
                id,
                currentPage,
                pageSize,
                searchText,
                selectedCategory,
                selectedSubCategory,
                selectedAgent,
                selectedTrainer,
                selectedIsLastYearPaid,
                scsNumberSearch,
                nameSearch,
                selectedPriority,
                selectedClass
            );
            fetchCategoriesDropdown();
            fetchSubCategoriesDropdown();
            fetchTrainerData();
            fetchAgentsData();
            fetchPriorityData();
            fetchClasses();
        }
    }, [userPermissions]);

    useEffect(() => {
        fetchData(
            id,
            currentPage,
            pageSize,
            searchText,
            selectedCategory,
            selectedSubCategory,
            selectedAgent,
            selectedTrainer,
            selectedIsLastYearPaid,
            scsNumberSearch,
            nameSearch,
            selectedPriority,
            selectedClass
        );
    }, [id, currentPage, pageSize, searchText, selectedCategory, selectedSubCategory, selectedAgent, selectedTrainer, selectedIsLastYearPaid, scsNumberSearch, nameSearch, selectedPriority, selectedClass])

    const handleApplyClick = () => {
        if (dropdownMenuRef.current) {
            dropdownMenuRef.current.classList.remove("show");
        }
    };

    const getModalContainer = () => {
        const modalElement = document.getElementById("modal-datepicker");
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };

    const options = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
        },
    };

    const fetchCategoriesDropdown = async () => {
        const response = await fetch(
            `${webApi}/wizklub/wizklub_ticket_group_category_access_dropdown/`,
            options
        );
        const data = await response.json();
        setCategories(data);
    };

    const fetchPriorityData = async () => {
        const response = await fetch(
            `${webApi}/wizklub/wizklub_priorities_dropdown/`,
            options
        );
        const data = await response.json();
        setPriorities(data);
    };

    const fetchSubCategoriesDropdown = async () => {
        const response = await fetch(
            `${webApi}/wizklub/wizklub_ticket_group_subcategory_access_dropdown/`,
            options
        );
        const data = await response.json();
        setSubCategories(data);
    };

    const fetchClasses = async () => {
        const response = await fetch(
            `${webApi}/branches/wizklub_class_names_dropdown/`,
            options
        );
        const data = await response.json();
        setClasses(data);
    };

    const fetchAgentsData = async () => {
        try {
            const response = await fetch(
                `${webApi}/teammgmt/get_team_members_by_teammgmt/2/`,
                options
            );
            const data = await response.json();
            setAgentsDropdown(data);
        } catch (error) {
            console.error("Failed to fetch agents", error);
        }
    };
    const fetchTrainerData = async () => {
        try {
            const response = await fetch(
                `${webApi}/wizklub/wizklub_trainers_dropdown/`,
                options
            );
            const data = await response.json();
            setTrainerDropdown(data);
        } catch (error) {
            console.error("Failed to fetch agents", error);
        }
    };

    const fetchGroupsData = async (
        id: number,
        page: number,
        pageSize: number,
        searchText: string,
        category: number,
        subCategory: number,
        agent: number,
        trainer: number,
        isLasterYearPaid: string,
        scsNumber: string,
        name: string,
        priority: number,
        className: number,
    ) => {
        let apiUrl = `${webApi}/wizklub/wizklub_tickets_for_trainer/?branch_id=${id}&page=${page}&page_size=${pageSize}&is_last_year_paid=${isLasterYearPaid}`;
        if (searchText) apiUrl += `&search=${searchText}`;
        if (category) apiUrl += `&category=${category}`;
        if (subCategory) apiUrl += `&subcategory=${subCategory}`;
        if (agent) apiUrl += `&agent_name=${agent}`;
        if (trainer) apiUrl += `&wizklub_trainer=${trainer}`;
        // if (isLasterYearPaid) apiUrl += `&is_last_year_paid=${isLasterYearPaid}`;
        if (scsNumber) apiUrl += `&SCS_Number=${scsNumber}`;
        if (name) apiUrl += `&name=${name}`;
        if (priority) apiUrl += `&priority=${priority}`;
        if (className) apiUrl += `&student_class=${className}`;
        const response = await fetch(
            apiUrl,
            options
        );
        if (!response.ok) {
            if (response.status === 404) {
                return await response.json();
            }
            const errorData = await response.json();
            if (errorData.code === "token_not_valid") {
                navigate("/academic/sri-chaitanya/crm/landing-page");
            }
            throw new Error(errorData.detail || "Failed to fetch user data");
        }
        return await response.json();
    };

    const fetchData = async (
        id: number,
        page: number,
        pageSize: number,
        searchText: string,
        category: number,
        subCategory: number,
        agent: number,
        trainer: number,
        isLasterYearPaid: string,
        scsNumber: string,
        name: string,
        priority: number,
        className: number,
    ) => {
        setIsLoading(true); // Start loading
        try {
            const [groupsData] = await Promise.all([
                fetchGroupsData(id, page, pageSize, searchText, category, subCategory, agent, trainer, isLasterYearPaid, scsNumber, name, priority, className),
            ]);
            setTotalPages(groupsData.total_pages);
            setAdmin(groupsData.results);
            setTotalCount(groupsData.total_count);
            setFrom(groupsData.from);
            setTo(groupsData.to);
            setTotalCount(groupsData.total_count);
            setCurrentPage(groupsData.current_page_number);
            setToastMessage(groupsData.message || "submitted successfully!");
            setShowSuccessToast(true);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false); // Stop loading
        }
    };

    useEffect(() => {
        console.log(admin);
    }, [admin])

    const handleTableChange = (pagination: any) => {
        const { current, pageSize } = pagination;
        setCurrentPage(current);
        setPageSize(pageSize);
        // fetchData(
        //     id,
        //     current,
        //     pageSize,
        //     searchText,
        //     selectedDepartment,
        //     selectedDesignation,
        //     nameSearch
        // ); // Fetch new data based on the updated pagination
    };

    const handleSearch = (value: string) => {
        setSearchText(value);
        // fetchData(
        //     id,
        //     currentPage,
        //     pageSize,
        //     value,
        //     selectedDepartment,
        //     selectedDesignation,
        //     nameSearch
        // );
    };

    const [loading, setLoading] = useState(false);

    const handleExportClick = async () => {

        window.location.href = `${webApi}/exports/export_agentwise_wizklub_call_logs/${id}?token=${jwtToken}`
    };

    const columns: ColumnsType<any> = [
        {
            title: (
                <span>
                    ScsNumber
                    {scsNumberSearch && (
                        <span style={{ marginLeft: 8, display: "inline-flex", alignItems: "center" }}>
                            <span style={{ color: "#1890ff", marginRight: 4 }}>({nameSearch})</span>
                            <CloseCircleOutlined
                                onClick={() => {
                                    setScsNumberSearch("");
                                }}
                                style={{ color: "red", cursor: "pointer" }}
                            />
                        </span>
                    )}
                </span>
            ),

            dataIndex: "SCS_Number",
            key: "SCS_Number",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }: FilterDropdownProps) => (
                <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                    <Input
                        placeholder="SCS Number"
                        value={selectedKeys[0]}
                        onChange={(e) =>
                            setSelectedKeys(e.target.value ? [e.target.value] : [])
                        }
                        onPressEnter={() => {
                            confirm();
                            setScsNumberSearch(selectedKeys[0] as string);
                        }}
                        style={{ marginBottom: 8, display: "block" }}
                    />
                </div>
            ),
            filterIcon: (filtered: boolean) => (
                <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
            ),
            // onFilter: (value: string, record: { SCS_Number: { toString: () => string; }; }) =>
            //     record.SCS_Number?.toString().toLowerCase().includes((value as string).toLowerCase()),
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                <Link
                    to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=6`}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: (
                <span>
                    Name
                    {nameSearch && (
                        <span style={{ marginLeft: 8, display: "inline-flex", alignItems: "center" }}>
                            <span style={{ color: "#1890ff", marginRight: 4 }}>({nameSearch})</span>
                            <CloseCircleOutlined
                                onClick={() => {
                                    setNameSearch("");
                                }}
                                style={{ color: "red", cursor: "pointer" }}
                            />
                        </span>
                    )}
                </span>
            ),

            dataIndex: "name",
            key: "name",
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }: FilterDropdownProps) => (
                <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                    <Input
                        placeholder="Name"
                        value={selectedKeys[0]}
                        onChange={(e) =>
                            setSelectedKeys(e.target.value ? [e.target.value] : [])
                        }
                        onPressEnter={() => {
                            confirm();
                            setNameSearch(selectedKeys[0] as string);
                        }}
                        style={{ marginBottom: 8, display: "block" }}
                    />
                </div>
            ),
            filterIcon: (filtered: boolean) => (
                <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
            ),
            // onFilter: (value: string, record: { SCS_Number: { toString: () => string; }; }) =>
            //     record.SCS_Number?.toString().toLowerCase().includes((value as string).toLowerCase()),
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                <Link
                    to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=6`}
                >
                    {text}
                </Link>
            ),
        },

        {
            title: (
                <span>
                    Class{selectedClass !== 0 ? ` (${classes.find(state => state.class_name_id === selectedClass)?.name})` : ""}
                    {selectedClass !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearClass}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>

            ),
            dataIndex: "student_class",
            key: "student_class",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Class"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = classes.find((s) => s.class_name_id === value);
                            setSelectedKeys(selected ? [selected.name] : []);
                            setSelectedClass(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {classes.map((state) => (
                            <Select.Option key={state.class_name_id} value={state.class_name_id}>
                                {state.name}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { student_class: string }) => record.student_class === value,

            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                <Link
                    to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=6`}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: "Section",
            dataIndex: "student_section",
            key: "student_section",
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                <Link
                    to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=6`}
                >
                    {text}
                </Link>
            ),
        },

        // {
        //     title: (
        //         <span>
        //             Category{selectedCategory !== 0 ? ` (${categories.find(state => state.category_id === selectedCategory)?.category_name})` : ""}
        //             {selectedCategory !== 0 && (
        //                 <CloseCircleOutlined
        //                     onClick={handleClearCategory}
        //                     style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
        //                 />
        //             )}
        //         </span>

        //     ),
        //     dataIndex: "category_name",
        //     key: "category_name",
        //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        //         <div style={{ padding: 8 }}>
        //             <Select
        //                 showSearch
        //                 placeholder="Category"
        //                 style={{ width: 188 }}
        //                 value={selectedKeys[0]}
        //                 onChange={(value) => {
        //                     const selected = categories.find((s) => s.category_id === value);
        //                     setSelectedKeys(selected ? [selected.category_name] : []);
        //                     setSelectedCategory(value);
        //                     confirm();
        //                 }}
        //                 allowClear
        //                 filterOption={(input, option) =>
        //                     typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
        //                 }
        //             >
        //                 {categories.map((state) => (
        //                     <Select.Option key={state.category_id} value={state.category_id}>
        //                         {state.category_name}
        //                     </Select.Option>
        //                 ))}
        //             </Select>
        //         </div>
        //     ),
        //     onFilter: (value: any, record: { category_name: string }) => record.category_name === value,

        //     render: (
        //         text:
        //             | string
        //             | number
        //             | boolean
        //             | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        //             | Iterable<React.ReactNode>
        //             | React.ReactPortal
        //             | null
        //             | undefined,
        //         record: { student_id: any }
        //     ) => (
        //         <Link
        //             to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=6`}
        //         >
        //             {text}
        //         </Link>
        //     ),
        // },
        // {
        //     title: (
        //         <span>
        //             Sub Category{selectedSubCategory !== 0 ? ` (${subCategories.find(state => state.subcategory_id === selectedSubCategory)?.subcategory_name})` : ""}
        //             {selectedSubCategory !== 0 && (
        //                 <CloseCircleOutlined
        //                     onClick={handleClearSubCategory}
        //                     style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
        //                 />
        //             )}
        //         </span>

        //     ),
        //     dataIndex: "subcategory_name",
        //     key: "subcategory_name",
        //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        //         <div style={{ padding: 8 }}>
        //             <Select
        //                 showSearch
        //                 placeholder="Sub Catgeory"
        //                 style={{ width: 188 }}
        //                 value={selectedKeys[0]}
        //                 onChange={(value) => {
        //                     const selected = subCategories.find((s) => s.subcategory_id === value);
        //                     setSelectedKeys(selected ? [selected.subcategory_name] : []);
        //                     setSelectedSubCategory(value);
        //                     confirm();
        //                 }}
        //                 allowClear
        //                 filterOption={(input, option) =>
        //                     typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
        //                 }
        //             >
        //                 {subCategories.map((state) => (
        //                     <Select.Option key={state.subcategory_id} value={state.subcategory_id}>
        //                         {state.subcategory_name}
        //                     </Select.Option>
        //                 ))}
        //             </Select>
        //         </div>
        //     ),
        //     onFilter: (value: any, record: { subcategory_name: string }) => record.subcategory_name === value,
        //     render: (
        //         text:
        //             | string
        //             | number
        //             | boolean
        //             | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        //             | Iterable<React.ReactNode>
        //             | React.ReactPortal
        //             | null
        //             | undefined,
        //         record: { student_id: any }
        //     ) => (
        //         <Link
        //             to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=6`}
        //         >
        //             {text}
        //         </Link>
        //     ),
        // },
        {
            title: (
                <span>
                    Agent{selectedAgent !== 0 ? ` (${agentsDropdown.find(state => state.id === selectedAgent)?.username})` : ""}
                    {selectedAgent !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearAgent}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>

            ),
            dataIndex: "agent_name",
            key: "agent_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Agent"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = agentsDropdown.find((s) => s.id === value);
                            setSelectedKeys(selected ? [selected.username] : []);
                            setSelectedAgent(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {agentsDropdown.map((state) => (
                            <Select.Option key={state.id} value={state.id}>
                                {state.username}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { agent_name: string }) => record.agent_name === value,
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                <Link
                    to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=6`}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: (
                <span>
                    Trainer{selectedTrainer !== 0 ? ` (${trainerDropdown.find(state => state.id === selectedTrainer)?.username})` : ""}
                    {selectedTrainer !== 0 && (
                        <CloseCircleOutlined
                            onClick={handleClearTrainer}
                            style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                        />
                    )}
                </span>

            ),
            dataIndex: "trainer_name",
            key: "trainer_name",
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        showSearch
                        placeholder="Trainer"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            const selected = trainerDropdown.find((s) => s.id === value);
                            setSelectedKeys(selected ? [selected.username] : []);
                            setSelectedTrainer(value);
                            confirm();
                        }}
                        allowClear
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {trainerDropdown.map((state) => (
                            <Select.Option key={state.id} value={state.id}>
                                {state.username}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            ),
            onFilter: (value: any, record: { trainer_name: string }) => record.trainer_name === value,
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                <Link
                    to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=6`}
                >
                    {text}
                </Link>
            ),
        },
        {
            title: (
                <span>
                    isLastYearPaid
                    {selectedIsLastYearPaid !== "" && (
                        <>
                            {`${selectedIsLastYearPaid ? ' (Yes)' : ' (No)'}`}
                            <CloseCircleOutlined
                                onClick={handleClearIsLastYearPaid}
                                style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
                            />
                        </>
                    )}
                </span>
            ),
            dataIndex: "is_last_year_paid",
            key: "is_last_year_paid",
            render: (value: boolean) => (value ? "Yes" : "No"),
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
                <div style={{ padding: 8 }}>
                    <Select
                        placeholder="Select Payment Status"
                        style={{ width: 188 }}
                        value={selectedKeys[0]}
                        onChange={(value) => {
                            setSelectedKeys([value]);
                            setSelectedIsLastYearPaid(value); // <-- Updated state handler
                            confirm();
                        }}
                        allowClear
                    >
                        <Select.Option value={true}>Yes</Select.Option>
                        <Select.Option value={false}>No</Select.Option>
                    </Select>
                </div>
            ),
            // onFilter: (value: boolean, record: { is_last_year_paid: boolean }) =>
            //     record.is_last_year_paid === value,
        },
        {
            title: "No.Of.Calls",
            dataIndex: "no_of_calls",
            render: (
                text:
                    | string
                    | number
                    | boolean
                    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
                    | Iterable<React.ReactNode>
                    | React.ReactPortal
                    | null
                    | undefined,
                record: { student_id: any }
            ) => (
                <Link
                    to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=6`}
                >
                    {text}
                </Link>
            ),
        },
        // {
        //     title: (
        //         <span>
        //             Priority{selectedPriority !== 0 ? ` (${priorities.find(state => state.priority_id === selectedPriority)?.priority_name})` : ""}
        //             {selectedPriority !== 0 && (
        //                 <CloseCircleOutlined
        //                     onClick={handleClearPriority}
        //                     style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
        //                 />
        //             )}
        //         </span>

        //     ),
        //     dataIndex: "priority_name",
        //     key: "priority_name",
        //     filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        //         <div style={{ padding: 8 }}>
        //             <Select
        //                 showSearch
        //                 placeholder="Priority"
        //                 style={{ width: 188 }}
        //                 value={selectedKeys[0]}
        //                 onChange={(value) => {
        //                     const selected = priorities.find((s) => s.priority_id === value);
        //                     setSelectedKeys(selected ? [selected.priority_name] : []);
        //                     setSelectedPriority(value);
        //                     confirm();
        //                 }}
        //                 allowClear
        //                 filterOption={(input, option) =>
        //                     typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
        //                 }
        //             >
        //                 {priorities.map((state) => (
        //                     <Select.Option key={state.priority_id} value={state.priority_id}>
        //                         {state.priority_name}
        //                     </Select.Option>
        //                 ))}
        //             </Select>
        //         </div>
        //     ),
        //     onFilter: (value: any, record: { priority_name: string }) => record.priority_name === value,
        //     render: (
        //         text:
        //             | string
        //             | number
        //             | boolean
        //             | React.ReactElement<any, string | React.JSXElementConstructor<any>>
        //             | Iterable<React.ReactNode>
        //             | React.ReactPortal
        //             | null
        //             | undefined,
        //         record: { student_id: any }
        //     ) => (
        //         <Link
        //             to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=6`}
        //         >
        //             {text}
        //         </Link>
        //     ),
        // }
        // {
        //     title: "Class",
        //     dataIndex: "class_teacher_class_name",
        // },
        // {
        //     title: "Section",
        //     dataIndex: "class_teacher_section_name",
        // },

    ];

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    {/* Page Header */}
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="page-title mb-1">
                                Wizklub Trainer Students Details
                            </h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={routes.wizklubTrainerDashboard}>Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to={routes.wizklubTrainerBranches}>Branches</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Wizklub Trainer Students Details
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                            {/* {checkPermission("can_export_wizklub_agent_wise_call_logs", "calllog") && (
              <button className="btn btn-primary me-2" onClick={handleExportClick} disabled={loading}>
              {loading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                "Export"
              )}
            </button>
            )} */}
                        </div>
                    </div>
                    {/* /Page Header */}
                    {/* Guardians List */}
                    <div
                        className="card "
                        style={{
                            width: "100%",
                            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                            borderRadius: "10px",
                        }}
                    >
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
                            <h4 className="mb-3">Wizklub Trainer Students List</h4>
                            <div
                                className="d-flex align-items-center flex-wrap"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                }}
                            >
                                <div
                                    className="d-flex align-items-center"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <div style={{ position: "relative" }}>
                                        {/* <div
                      onClick={() => setShowCalendar1(!showCalendar1)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px 15px",
                        background: "white",
                        borderRadius: "20px",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "#34303D",
                        cursor: "pointer",
                        border: "1px solid #ddd",
                        minWidth: "200px",
                        justifyContent: "center",
                        // marginTop: "5px",
                        marginRight: "5px",
                        marginBottom: "7px",
                      }}
                    >
                      {format(dateRange[0].startDate, "dd MMM yy")} –{" "}
                      {format(dateRange[0].endDate, "dd MMM yy")}
                      <span style={{ marginLeft: "10px" }}>▼</span>
                    </div> */}

                                        {/* Calendar Popup (Positioned Below) */}
                                        {/* {showCalendar1 && (
                      <div
                        style={{
                          position: "absolute",
                          zIndex: 2000,
                          background: "white",
                          borderRadius: "10px",
                          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                          padding: "5px",
                          left: "-130px" ,
                        }}
                      >
                        <DateRange
                          ranges={dateRange}
                          onChange={(item) =>
                            setDateRange([
                              {
                                startDate:
                                  item.selection.startDate || new Date(),
                                endDate: item.selection.endDate || new Date(),
                                key: "selection",
                              },
                            ])
                          }
                          moveRangeOnFirstSelection={false}
                          rangeColors={["blue"]} 
                        />
                      </div>
                    )} */}
                                    </div>

                                    {/* <button
                    className="btn btn-primary"
                    style={{
                      backgroundColor: "#28a745",
                      borderColor: "#28a745",
                      color: "#fff",
                      height: "38px",
                      padding: "6px 12px",
                      display: "flex",
                      alignItems: "center",
                     
                      marginBottom: "7px",
                      borderRadius: "19px",
                    }}
                    onClick={handleFetchData}
                  >
                    Search
                  </button> */}
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0 py-3">
                            {/* <div
                                className="serch-global text-right"
                                style={{ marginRight: "15px" }}
                            >
                                <input
                                    type="search"
                                    className="form-control form-control-sm mb-3 w-auto float-end"
                                    value={searchText}
                                    placeholder="Search"
                                    onChange={(e) => handleSearch(e.target.value)}
                                    aria-controls="DataTables_Table_0"
                                ></input>
                            </div> */}
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        height: "100vh",
                                        paddingTop: "20px",
                                    }}
                                >
                                    <Spin /> {/* Display loader while loading */}
                                </div>
                            ) : (
                                <Table
                                    columns={columns}
                                    dataSource={admin}
                                    Selection={false}
                                    pagination={{
                                        current: currentPage,
                                        pageSize: pageSize,
                                        locale: { items_per_page: "" },
                                        nextIcon: <span>Next</span>,
                                        prevIcon: <span>Prev</span>,
                                        defaultPageSize: 10,
                                        showSizeChanger: true,
                                        total: totalCount,
                                        showTotal: (total: any, range: any[]) =>
                                            `${range[0]}-${range[1]} of ${total}`,
                                        pageSizeOptions: ["10", "20", "30", "50", "100"],
                                    }}
                                    onChange={handleTableChange} // Move this outside of pagination
                                    onSearch={handleSearch}
                                    searchText={searchText}
                                />
                            )}
                        </div>
                    </div>
                    {/* /Guardians List */}
                </div>
            </div>
            <>
                {/* Delete Modal */}
                <div className="modal fade" id="delete-modal">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <form>
                                <div className="modal-body text-center">
                                    <span className="delete-icon">
                                        <i className="ti ti-trash-x" />
                                    </span>
                                    <h4>Confirm Deletion</h4>
                                    <p>
                                        You want to delete all the marked items, this cant be undone
                                        once you delete.
                                    </p>
                                    <div className="d-flex justify-content-center">
                                        <Link
                                            to="#"
                                            className="btn btn-light me-3"
                                            data-bs-dismiss="modal"
                                        >
                                            Cancel
                                        </Link>
                                        <Link
                                            to="#"
                                            data-bs-dismiss="modal"
                                            className="btn btn-danger"
                                        >
                                            Yes, Delete
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {/* /Delete Modal */}
            </>
        </div>
    );
};

export default WizklubTrainerStudents;
